import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMABAA080AdminRegisterBanner, postMABAA080RecruitExpiredCloneDefault } from '../../../../services/Api';
import { formatDate } from '../../../../utils';
const PopupMABAA080_7 = ({ onClose, additionalData }) => {
    const { memberID, recruitSeq, goodName, paySeq } = additionalData;
    const [popupDataComment, setPopupDataComment] = useState([]);
    const [payload, setPayload] = useState({
        memberID,
        recruitSeq,
        paySeq,
        comment: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const formatDatePayload = (date) => {
        if (date) {
            return moment(date).format('YYYY-MM-DD');
        } else {
            return;
        }
    };

    useEffect(() => {
        getMABAA080AdminRegisterBanner({
            params: {
                memberID,
                recruitSeq,
            },
        })
            .then(({ data }) => {
                setPopupDataComment(data.comments);
            })
            .catch((error) => console.log(error));
    }, [memberID, recruitSeq]);

    const handleSave = () => {
        if (!payload.recruitFrom) {
            alert('채용시작일 입력해 주세요.');
            return;
        }
        if (!payload.recruitEnd) {
            alert('채용종료일 입력해 주세요.');
            return;
        }
        const formattedRecruitStart = formatDatePayload(payload.recruitFrom);
        const formattedRecruitEnd = formatDatePayload(payload.recruitEnd);

        const updatedPayload = {
            ...payload,
            recruitFrom: formattedRecruitStart,
            recruitEnd: formattedRecruitEnd,
        };

        postMABAA080RecruitExpiredCloneDefault(updatedPayload)
            .then(() => {
                alert('완료되었습니다.');
                onClose();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="dental-information" className="dental-information dental-information_2">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={onClose} />
                        <div className="popup-header">[재사용]</div>
                        <div className="popup-title">[덴탈잡] 채용광고 수정 및 마감</div>
                        <div className="table-dental-information">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>아이디</td>
                                        <td>{memberID}</td>
                                    </tr>
                                    <tr>
                                        <td>상품명</td>
                                        <td>{goodName}</td>
                                    </tr>
                                    <tr>
                                        <td>채용일자</td>
                                        <td>
                                            <div className="flex group-item">
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleInputChange({
                                                            target: { name: 'recruitFrom', value: date },
                                                        })
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={payload.recruitFrom}
                                                    maxDate={payload.recruitEnd || null}
                                                />
                                                <span>~</span>
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleInputChange({
                                                            target: { name: 'recruitEnd', value: date },
                                                        })
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={payload.recruitEnd}
                                                    minDate={payload.recruitFrom || null}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <td>사용여부</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="isEnd" value={payload.isEnd} onChange={handleInputChange}>
                                                    <option value="N">사용</option>
                                                    <option value="Y">미사용</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td>Comment</td>
                                        <td colSpan={3}>
                                            <textarea name="comment" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="note-table">
                            ※ Comment 등록형식 : [상품명]/ [Comment] . ex) 프리미엄배너 / 전화가 안와요 불만)
                        </div>
                        <div className="group-btn">
                            <button className="popup-button" onClick={handleSave}>
                                등록 / 수정
                            </button>
                        </div>
                        <div className="table-comment-results">
                            <div className="table-comment-results-title">
                                등록된 Comment (
                                {popupDataComment && popupDataComment.length > 0 ? popupDataComment.length : 0})
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th>Seq</th>
                                        <th>등록일</th>
                                        <th>관리자명</th>
                                        <th>등록사이트</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {popupDataComment && popupDataComment.length > 0 ? (
                                        popupDataComment.map((item) => (
                                            <tr key={item.seq}>
                                                <td>{item.seq}</td>
                                                <td>{formatDate(item.addDate)}</td>
                                                <td>{item.adminName}</td>
                                                <td>{item.sitePos}</td>
                                                <td>{item.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                데이타가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMABAA080_7;
